export const TOKEN_KEY = "auth-token";
export const REFRESH_TOKEN_KEY = "refresh-token";
export const ACTIVE_ASSOCIATION_KEY = "active-association";
